import React from 'react';
import { TextOnlyUnderlinedButton } from '../../Components';
import { routes } from '../../routes';
import { translate } from './translate';

export const UpdateOrderButton = (props) => (
  <TextOnlyUnderlinedButton
    onClick={() => {
      props.push(routes.orderUpdate(props.id), {
        routeOnSubmit: routes.orderList,
      });
    }}
    text={translate('updateOrder')}
  />
);
